import { apiClient } from "@/lib/api/client";

export type ExpenseCategoryDto = {
  id: string;
  name: string;
  description: string | null;
  is_active: boolean;
};

export type ExpenseCategoryInput = Pick<ExpenseCategoryDto, "name" | "description" | "is_active">;

export type ExpenseCategoryPageDto = {
  items: ExpenseCategoryDto[];
  total: number;
  next_offset: number | null;
};

export async function listExpenseCategories(params: { search?: string; limit?: number; offset?: number; includeInactive?: boolean } = {}): Promise<ExpenseCategoryPageDto> {
  const { data } = await apiClient.get<ExpenseCategoryPageDto>("/expense-categories", {
    params: {
      include_inactive: params.includeInactive ?? true,
      search: params.search || undefined,
      limit: params.limit ?? 25,
      offset: params.offset ?? 0,
    },
  });
  return data;
}

export async function createExpenseCategory(body: ExpenseCategoryInput): Promise<ExpenseCategoryDto> {
  const { data } = await apiClient.post<ExpenseCategoryDto>("/expense-categories", body);
  return data;
}

export async function updateExpenseCategory(id: string, body: ExpenseCategoryInput): Promise<ExpenseCategoryDto> {
  const { data } = await apiClient.patch<ExpenseCategoryDto>(`/expense-categories/${id}`, body);
  return data;
}
